import * as THREE from 'three';
import { useMemo, useRef, useLayoutEffect } from 'react';
import { useFrame } from '@react-three/fiber';
import boldUrl from './Kanit_Bold.json';
import { Text3D } from '@react-three/drei';

export default function FiberText({ children, vAlign = 'right', hAlign = 'right', size = 1.5, color = 'white', ...props }) {
  const config = useMemo(
    () => ({
      size: props?.size,
      height: props?.height,
      curveSegments: 1,
      bevelEnabled: false,
      bevelThickness: 1,
      bevelSize: 1,
      bevelOffset: 0,
      bevelSegments: 1
    }),
    []
  );

  const mesh = useRef();

  useLayoutEffect(() => {
    const size = new THREE.Vector3();
    mesh.current.geometry.computeBoundingBox();
    mesh.current.geometry.boundingBox.getSize(size);
    mesh.current.position.x = hAlign === 'center' ? -size.x / 2 : hAlign === 'right' ? 0 : -size.x;
    mesh.current.position.z = hAlign === 'center' ? size.x / 2 : size.x / 2;
    mesh.current.position.y = vAlign === 'center' ? -size.y / 2 : vAlign === 'top' ? 0 : -size.y;
  }, [children]);

  // dostopas poziciji kamere in preko quaterniona nastavis usmeritev
  useFrame(({ camera }) => {
    mesh.current.quaternion.copy(camera.quaternion);
  });

  return (
    <group {...props} scale={[0.1 * size, 0.1 * size, 0.1 * size]}>
      <Text3D ref={mesh} font={boldUrl} {...config}>
        {children}
        <meshPhongMaterial
          color={color}
          emissive={'black'} // Adds an emissive color for better visibility
          emissiveIntensity={0.3} // Controls the intensity of the emissive color
          specular={0x555555} // Adds a bit of specular highlight
          shininess={50} // Adjust shininess to control the specular reflection
        />
      </Text3D>
    </group>
  );
}
